import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: calc(100% - 60px);
  width: -webkit-fill-available;
`;
